/**
 * Collections permission codes (FT9-B33, `internal/ar/permissions.go` PermCollectionsRead /
 * PermCollectionsManage).
 *
 * Kept beside the feature because `modules/ar/permissions.ts` is outside this packet's
 * files; the strings are the server's own. Each one is the permission its route declares
 * (`internal/ar/collections_routes.go`):
 *
 *   GET   /ar-collections/worklist     ar.collections.read
 *   GET   /ar-promises                 ar.collections.read
 *   POST  /ar-promises                 ar.collections.manage
 *   PATCH /ar-promises/:id             ar.collections.manage
 *   GET   /ar-collections-settings     ar.collections.read
 *   PUT   /ar-collections-settings     ar.collections.manage
 */
export const AR_COLLECTIONS_PERMISSIONS = {
  read: 'ar.collections.read',
  manage: 'ar.collections.manage',
} as const
